import { Group } from "../../../group";
import classnames from "classnames";
import styles from "./sidebar-content.module.scss";
import { ISidebarItemWrapperProps } from "./sidebar-content.types";

/**
 * Base wrapper component providing consistent styling and click handling for sidebar items.
 * @param {React.ReactNode} props.children - The content to render inside the wrapper.
 * @param {Function} props.onClick - Optional click handler for the wrapper.
 * @param {boolean} props.active - Optional flag indicating if this item is currently active.
 * @param {string} props.data-testid - Optional test identifier for the wrapper element.
 * @returns {JSX.Element} The SidebarItemWrapper component.
 */
const SidebarItemWrapper = ({ children, onClick, active, "data-testid": dataTestId }: ISidebarItemWrapperProps) => {
    return (
        <Group
            wrap="nowrap"
            flex="1 0 auto"
            gap="sm"
            p="sm"
            w="100%"
            justify="flex-start"
            data-active={active}
            className={classnames(styles["sidebar-content-item"], "global-menu-item")}
            onClick={onClick}
            data-testid={dataTestId}
        >
            {children}
        </Group>
    );
};

export { SidebarItemWrapper };
